import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1264.8398,456.278941 C1295.85311,650.740726 1465.16897,799.939855 1668.85093,799.939855 C1671.36552,799.939855 1673.88011,799.939855 1676.3947,799.101658 L1676.3947,799.101658 L1676.3947,1629.75523 C1676.3947,1721.95694 1600.95694,1797.3947 1508.75523,1797.3947 L1508.75523,1797.3947 L167.63947,1797.3947 C75.4377617,1797.3947 0,1721.95694 0,1629.75523 L0,1629.75523 L0,623.918411 C0,531.716702 75.4377617,456.278941 167.63947,456.278941 L167.63947,456.278941 Z M754.377617,783.242964 L502.918411,783.242964 C364.615848,783.242964 251.459206,896.399606 251.459206,1034.70217 L251.459206,1034.70217 L251.459206,1202.34164 C251.459206,1340.6442 364.615848,1453.80085 502.918411,1453.80085 L502.918411,1453.80085 L754.377617,1453.80085 L754.377617,1286.16137 L502.918411,1286.16137 C456.817557,1286.16137 419.098676,1248.44249 419.098676,1202.34164 L419.098676,1202.34164 L419.098676,1034.70217 C419.098676,988.601315 456.817557,950.882434 502.918411,950.882434 L502.918411,950.882434 L754.377617,950.882434 L754.377617,783.242964 Z M1424.9355,783.242964 L1173.47629,783.242964 C1035.17373,783.242964 922.017087,896.399606 922.017087,1034.70217 L922.017087,1034.70217 L922.017087,1202.34164 C922.017087,1340.6442 1035.17373,1453.80085 1173.47629,1453.80085 L1173.47629,1453.80085 L1424.9355,1453.80085 L1424.9355,1286.16137 L1173.47629,1286.16137 C1127.37544,1286.16137 1089.65656,1248.44249 1089.65656,1202.34164 L1089.65656,1202.34164 L1089.65656,1034.70217 C1089.65656,988.601315 1127.37544,950.882434 1173.47629,950.882434 L1173.47629,950.882434 L1424.9355,950.882434 L1424.9355,783.242964 Z M1822.68529,121 L1920,219.320549 L1762.25126,378.661866 L1920,538.087002 L1822.68529,636.323732 L1664.93655,476.982415 L1507.10398,636.323732 L1409.78927,538.087002 L1567.62183,378.661866 L1409.78927,219.320549 L1507.10398,121 L1664.93655,280.425136 L1822.68529,121 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconClosedCaptioningOffSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconClosedCaptioningOffSolid, _Component);

  var _super = _createSuper(IconClosedCaptioningOffSolid);

  function IconClosedCaptioningOffSolid() {
    _classCallCheck(this, IconClosedCaptioningOffSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconClosedCaptioningOffSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconClosedCaptioningOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconClosedCaptioningOffSolid.displayName = "IconClosedCaptioningOffSolid";
  return IconClosedCaptioningOffSolid;
}(Component);

IconClosedCaptioningOffSolid.glyphName = 'closed-captioning-off';
IconClosedCaptioningOffSolid.variant = 'Solid';
IconClosedCaptioningOffSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconClosedCaptioningOffSolid;
export { IconClosedCaptioningOffSolid };